import * as React from "react";
import TablePagination from "@mui/material/TablePagination";

/**
 * The record count a list API reports, whatever it calls it, or null when it reports none.
 */
export const pickTotal = (res) => {
  const candidates = [
    res?.total_count, res?.totalCount, res?.total, res?.count,
    res?.data?.total_count, res?.data?.total,
  ];
  for (const c of candidates) {
    const n = Number(c);
    if (c !== undefined && c !== null && c !== "" && Number.isFinite(n)) return n;
  }
  return null;
};

/**
 * Same pagination bar as the Members table: rows per page 10 / 20 / 50, first / previous /
 * next / last, and "Page 1 of 12 | Total: 118 records".
 *
 * Props: count, page (0-based), rowsPerPage, onPageChange(newPage), onRowsPerPageChange(size)
 */
export default function ListPagination({ count, page, rowsPerPage, onPageChange, onRowsPerPageChange, options = [10, 20, 50] }) {
  if (!count || count <= 0) return null;
  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={(e, p) => onPageChange(p)}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={options}
      onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
      showFirstButton
      showLastButton
      labelDisplayedRows={({ page: p, count: c }) =>
        `Page ${p + 1} of ${Math.max(1, Math.ceil(c / rowsPerPage))}  |  Total: ${c} records`
      }
      sx={{
        borderTop: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        borderRadius: { xs: 0, sm: "0 0 10px 10px" },
        "& .MuiTablePagination-toolbar": {
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 1,
          py: 1,
        },
      }}
    />
  );
}
